import { chiliPayUserApi, type FetchUserMeNeedsTravelRuleData } from '@capsicum/common';
import { type RequestParams } from 'libs/common/services/api/__generated/http-client';

export const getUserNeedsTravelRule = async (params?: RequestParams): Promise<FetchUserMeNeedsTravelRuleData> => {
	const api = await chiliPayUserApi;

	const response = await api.fetchUserMeNeedsTravelRule(params);

	return response as FetchUserMeNeedsTravelRuleData;
};
